import React from 'react';
import { Grid, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    emptyGalleryLabel: {
        margin: theme.spacing(5, 0, 5, 0) 
    }
});

const EmptyGalleryLabel = (props) => {
    // Stock galleries are only ever empty because a search found nothing, so they keep the plain
    // wording. A gallery of the user's own uploads can say what to do about it.
    const { classes, text = 'Nothing Here' } = props;

    return (
        <Grid className={classes.emptyGalleryLabel}>
            <Typography 
                variant='subtitle2' 
                color='textSecondary'
            >
                {text}
            </Typography>
        </Grid>
    );
};

export default withStyles(EmptyGalleryLabel, styles);